<template>
    <div style="margin:10px">

        <Row style="margin-bottom: 20px">

            <Button type="success" shape="circle" icon="md-add" @click="onClickAdd" v-if="isOwner">创建 Vault</Button>
            <Button style="float:right" shape="circle" icon="md-refresh" @click="onClickRefresh"></Button>

        </Row>
        <Row type="flex" justify="start" align="top">
            <Spin size="large" style="height:100%;position:fixed" fix v-if="spinShow"></Spin>
            <Card style="width:48%;display: inline-block;margin: 10px" v-for="(item,index) in vaultList"
                  :key="item.address" v-if="item.isRelated || isOwner">
                <p slot="title">
                    <Icon type="ios-card"/>
                    {{item.name}}
                </p>
                <div slot="extra">
                    <a href="#" @click.prevent="onClickEditName(item)" v-if="isOwner">
                        <Icon type="md-create"/>
                        修改名称
                    </a>
                </div>

                <Collapse simple value="1">
                    <Panel name="1">
                        基本操作
                        <div slot="content">
                            <Row class="opRow">
                                地址： {{item.address}}
                                <Button type="text" icon="md-copy" @click="doCopy(item.address)"/>
                            </Row>

                            <Row class="opRow">
                                策略：
                                <Tag type="border" color="primary">{{item.strategyName}}</Tag>
                                <Button type="text" icon="md-create" @click="onClickEditStrategy(item)"
                                        v-if="item.isOwner"/>
                            </Row>

                            <Row class="opRow">
                                充值到Compound：
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.investTokenInfos && item.investTokenInfos[0] && item.availableInvestTokenBalances && item.availableInvestTokenBalances[0]">
                                <Col>
                                    <Input v-model="item.depositInvestValue0" placeholder="输入充币数量">
                                        <span slot="append">{{item.investTokenInfos[0].symbol}}</span>
                                    </Input>
                                </Col>
                                <Col
                                        style="margin-left: 8px;">
                                    <Button @click="onClickMaxDeposit(item,index, 0)">Wallet:
                                        {{divDecimals(item.availableInvestTokenBalances[0],item.investTokenInfos[0].decimals).toNumber()}}
                                    </Button>
                                </Col>
                                <Col style="margin-left: 8px">
                                    <Button type="warning" @click="onClickDepositToTargetPrj(item, 0)" v-if="item.isInvestTokenApproveds[0]">Deposit</Button>
                                    <Button type="warning" @click="onClickApprove(item, 0)" v-else>Approve</Button>
                                </Col>
                            </Row>
                            <Row class="opRow">
                                充值到Vault：
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.supportedTokenInfos && item.supportedTokenInfos[0] && item.availableSupportedTokenBalances && item.availableSupportedTokenBalances[0]">
                                <Col>
                                    <Input v-model="item.depositValue0" placeholder="输入充币数量">
                                        <span slot="append">{{item.supportedTokenInfos[0].symbol}}</span>
                                    </Input>
                                </Col>
                                <Col
                                        style="margin-left: 8px;">
                                    <Button @click="onClickMaxDeposit(item,index, 10)">Wallet:
                                        {{divDecimals(item.availableSupportedTokenBalances[0],item.supportedTokenInfos[0].decimals).toNumber()}}
                                    </Button>
                                </Col>
                                <Col style="margin-left: 8px">
                                    <Button type="warning" @click="onClickDeposit(item, 10)" v-if="item.isSupportedTokenApproveds[0]">Deposit</Button>
                                    <Button type="warning" @click="onClickApprove(item, 10)" v-else>Approve</Button>
                                </Col>
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.supportedTokenInfos && item.supportedTokenInfos[1] && item.availableSupportedTokenBalances && item.availableSupportedTokenBalances[1]">
                                <Col>
                                    <Input v-model="item.depositValue1" placeholder="输入充币数量">
                                        <span slot="append">{{item.supportedTokenInfos[1].symbol}}</span>
                                    </Input>
                                </Col>
                                <Col
                                        style="margin-left: 8px;">
                                    <Button @click="onClickMaxDeposit(item,index, 11)">Wallet:
                                        {{divDecimals(item.availableSupportedTokenBalances[1],item.supportedTokenInfos[1].decimals).toNumber()}}
                                    </Button>
                                </Col>
                                <Col style="margin-left: 8px">
                                    <Button type="warning" @click="onClickDeposit(item, 11)" v-if="item.isSupportedTokenApproveds[1]">Deposit</Button>
                                    <Button type="warning" @click="onClickApprove(item, 11)" v-else>Approve</Button>
                                </Col>
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.supportedTokenInfos && item.supportedTokenInfos[2] && item.availableSupportedTokenBalances && item.availableSupportedTokenBalances[2]">
                                <Col>
                                    <Input v-model="item.depositValue2" placeholder="输入充币数量">
                                        <span slot="append">{{item.supportedTokenInfos[2].symbol}}</span>
                                    </Input>
                                </Col>
                                <Col
                                        style="margin-left: 8px;">
                                    <Button @click="onClickMaxDeposit(item,index, 12)">Wallet:
                                        {{divDecimals(item.availableSupportedTokenBalances[2],item.supportedTokenInfos[2].decimals).toNumber()}}
                                    </Button>
                                </Col>
                                <Col style="margin-left: 8px">
                                    <Button type="warning" @click="onClickDeposit(item, 12)" v-if="item.isSupportedTokenApproveds[2]">Deposit</Button>
                                    <Button type="warning" @click="onClickApprove(item, 12)" v-else>Approve</Button>
                                </Col>
                            </Row>

                            <Row class="opRow">
                                Vault资产状况：
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.investTokenInfos && item.investTokenInfos[0] && item.investTokenBalances && item.investTokenBalances[0]">
                                <Col
                                        style="margin-left: 8px;">
                                    <Tag type="border" color="primary">{{item.investTokenInfos[0].symbol}}:
                                        {{divDecimals(item.investTokenBalances[0],item.investTokenInfos[0].decimals).toNumber()}}
                                    </Tag>
                                </Col>
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator">
                                <Col
                                        style="margin-left: 8px;" v-if="item.isOperator && item.investTokenInfos && item.investTokenInfos[1] && item.investTokenBalances && item.investTokenBalances[1]">
                                    <Tag type="border" color="primary">{{item.investTokenInfos[1].symbol}}:
                                        {{divDecimals(item.investTokenBalances[1],item.investTokenInfos[1].decimals).toNumber()}}
                                    </Tag>
                                </Col>
                                <Col
                                        style="margin-left: 8px;" v-if="item.borrowTokenInfos && item.borrowTokenInfos[0] && item.borrowTokenBalances && item.borrowTokenBalances[0]">
                                    <Tag type="border" color="primary">{{item.borrowTokenInfos[0].symbol}}:
                                        {{divDecimals(item.borrowTokenBalances[0],item.borrowTokenInfos[0].decimals).toNumber()}}
                                    </Tag>
                                </Col>
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.rewardTokenInfos && item.rewardTokenInfos[0] && item.rewardTokenBalances && item.rewardTokenBalances[0]">
                                <Col
                                        style="margin-left: 8px;">
                                    <Tag type="border" color="primary">{{item.rewardTokenInfos[0].symbol}}:
                                        {{divDecimals(item.rewardTokenBalances[0],item.rewardTokenInfos[0].decimals).toNumber()}}
                                    </Tag>
                                </Col>
                            </Row>


                            <Row class="opRow">
                                投入Strategy：
                            </Row>
                            <Row class="opRow" v-if="item.borrowInfo">
                                {{item.borrowInfo}}
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowTokenInfos">
                                <Col span="4">
                                    <Select v-model="item.collateralToken"
                                            filterable
                                            allow-create
                                            placeholder="抵押币种"
                                            @on-create="onCreateToken"
                                    >
                                        <Option v-for="token in tokenList"
                                                :value="token.address"
                                                :key="token.address">
                                            {{ token.symbol}}
                                        </Option>
                                    </Select>
                                </Col>
                                <Col span="4">
                                    <Select v-model="item.borrowToken"
                                            filterable
                                            allow-create
                                            placeholder="借贷币种"
                                            @on-create="onCreateToken"
                                    >
                                        <Option v-for="token in tokenList"
                                                :value="token.address"
                                                :key="token.address">
                                            {{ token.symbol}}
                                        </Option>
                                    </Select>
                                </Col>
                                <Col>
                                    <Input v-model="item.borrowTokenRatio" placeholder="输入借币比例(1-80)"/>
                                    </Input>
                                </Col>
                                <Col style="margin-left: 8px">
                                    <Button type="warning" @click="onClickCalcEarn(item, index)">Calc</Button>
                                </Col>
                                <Col style="margin-left: 8px">
                                    <Button type="warning" @click="onClickEarn(item)">Earn</Button>
                                </Col>
                            </Row>

                            <Row class="opRow">
                                从Strategy赎回收益：
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isHarvestor && item.rewardTokenInfos && item.rewardTokenInfos[0]">
                                <Col
                                        style="margin-left: 8px;"
                                        v-if="item.claimable && item.claimable[0]">
                                    <Tag type="border" color="primary">{{item.rewardTokenInfos[0].symbol}}:
                                        {{divDecimals(item.claimable[0],item.rewardTokenInfos[0].decimals).toNumber()}}
                                    </Tag>
                                </Col>
                                <Col style="margin-left: 8px">
                                    <Button type="success" @click="onClickClaim(item)">Claim</Button>
                                </Col>
                            </Row>

                            <Row class="opRow">
                                Strategy资产状况：
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator">
                                <Col
                                        style="margin-left: 8px;" v-if="item.riskIndex">
                                    <Tag type="border" color="primary">Utilization Rate:
                                        {{divDecimals(item.riskIndex, 6).toNumber()}}
                                    </Tag>
                                </Col>
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.investTokenInfos && item.investTokenInfos[0] && item.investedBalances && item.investedBalances[0]">
                                <Col
                                        style="margin-left: 8px;">
                                    <Tag type="border" color="primary">投入Compound资产: </Tag>
                                </Col>
                                <Col
                                        style="margin-left: 8px;">
                                    <Tag type="border" color="primary">{{item.investTokenInfos[0].symbol}}:
                                        {{divDecimals(item.investedBalances[0],item.investTokenInfos[0].decimals).toNumber()}}
                                    </Tag>
                                </Col>
                                <Col
                                        style="margin-left: 8px;" v-if="item.isOperator && item.investTokenInfos && item.investTokenInfos[1] && item.investedBalances && item.investedBalances[1]">
                                    <Tag type="border" color="primary">{{item.investTokenInfos[1].symbol}}:
                                        {{divDecimals(item.investedBalances[1],item.investTokenInfos[1].decimals).toNumber()}}
                                    </Tag>
                                </Col>
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator && item.borrowTokenInfos && item.borrowTokenInfos[0] && item.borrowedBalances && item.borrowedBalances[0]">
                                <Col
                                        style="margin-left: 8px;">
                                    <Tag type="border" color="primary">借出Compound资产: </Tag>
                                </Col>
                                <Col
                                        style="margin-left: 8px;">
                                    <Tag type="border" color="primary">{{item.borrowTokenInfos[0].symbol}}:
                                        {{divDecimals(item.borrowedBalances[0],item.borrowTokenInfos[0].decimals).toNumber()}}
                                    </Tag>
                                </Col>
                            </Row>
                            <Row type="flex" class="opRow" v-if="item.isOperator">
                                <Col style="margin-left: 8px">
                                    <Button type="success" @click="onClickExit(item)">Repay</Button>
                                </col>
                                <Col style="margin-left: 8px">
                                    <Button type="warning" @click="onClickRedeem(item)">Redeem</Button>
                                </col>
                            </Row>


                            <Row class="opRow" v-if="item.isOwner">
                                从Vault取回资金：
                            </Row>
                            <Row class="opRow" v-if="item.isOwner" type="flex">
                                <Col span="8" style="margin-left: 8px">
                                    <Input v-model="item.withdrawValue" placeholder="输入提币数量">
                                    </Input>
                                </Col>

                                <Col span="4">
                                    <Select v-model="item.withdrawToken"
                                            filterable
                                            allow-create
                                            placeholder="选择币种"
                                            @on-create="onCreateToken"
                                            @on-change="onSelectWithdrawToken(item,index)"
                                    >
                                        <Option v-for="token in tokenList"
                                                :value="token.address"
                                                :key="token.address">
                                            {{ token.symbol}}
                                        </Option>
                                    </Select>
                                </Col>

                                <Col style="margin-left: 8px;"
                                     v-if="item.withdrawToken && item.withdrawTokenInfo">
                                    <Button @click="onClickMaxWithdraw(item,index)">
                                        Max:
                                        {{divDecimals(item.withdrawTokenBalance,item.withdrawTokenInfo.decimals).toNumber()}}
                                    </Button>
                                </Col>
                                <Col span="6" style="margin-left: 8px">
                                    <Button type="error" @click="onClickWithdraw(item,index)">
                                        Withdraw
                                    </Button>
                                </Col>
                            </Row>
                            <Row class="opRow" v-if="item.isOwner && item.ethBalance > 0" type="flex">
                                <Col
                                        style="margin-left: 8px;">
                                    <Tag type="border" color="primary">ETH:
                                        {{divDecimals(item.ethBalance,18).toNumber()}}
                                    </Tag>
                                </Col>
                                <Col span="6" style="margin-left: 8px">
                                    <Button type="error" @click="onClickWithdrawETH(item,index)">
                                        Withdraw ETH
                                    </Button>
                                </Col>

                            </Row>

                        </div>
                    </Panel>
                    <Panel name="2">
                        权限管理
                        <div slot="content">
                            <Row class="opRow">
                                Owner：{{item.owner}}
                                <Button type="text" icon="md-create" @click="onClickEditOwner(item)"
                                        v-if="item.isOwner"/>

                            </Row>

                            <Row class="opRow" v-if="item.pendingOwner!=='0x0000000000000000000000000000000000000000'">
                                待接受 Owner：{{item.pendingOwner}}
                                <Button v-if="myAddr===item.pendingOwner" type="success" style="margin-left: 8px"
                                        @click="onClickAcceptOwner(item.address)">接受成为 Owner
                                </Button>
                            </Row>

                            <AccessControl :editable="item.isOwner" :vaultAddress="item.address"/>

                        </div>
                    </Panel>
                </Collapse>


            </Card>
            <Alert type="warning" show-icon v-if="!haveRole" style="width:80%">
                这里什么都没有
                <template slot="desc">
                    或许是因为你没有任何权限
                </template>
            </Alert>
        </Row>

        <Modal
                v-if=""
                v-model="modalShow"
                :title="modalTitle"
                :loading="modalLoading"
                @on-ok="modalDone">

            <Form ref="modalForm" :model="modalForm" :label-width="70" :rules="ruleValidate">
                <FormItem label="名称" prop="name" v-if="modalType==='create' || modalType==='vaultName'">
                    <Input v-model="modalForm.name" placeholder="输入金库名称"></Input>
                </FormItem>
                <FormItem label="Owner" prop="owner" v-if="modalType==='owner'">
                    <Input v-model="modalForm.owner" placeholder="输入提议的 Owner 地址"></Input>
                </FormItem>

                <FormItem label="策略" prop="strategy" v-if="modalType==='create' || modalType==='strategy'">
                    <Select
                            v-model="modalForm.strategy"
                            filterable
                            :placeholder="selectPlaceholder">
                        <Option v-for="(option, index) in selectList" :value="option.address" :key="index">
                            {{option.name}}
                        </Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>


    </div>
</template>

<script>
import TagList from '@/components/common/TagList'
import AccessControl from '@/components/role/AccessControl'
import { Strategy, Vault } from '@/config/abis'
import Store from '@/utils/store'
import contract from '@/utils/contracts/common'
import tools from '@/utils/contracts/tools'
import { waitForTx } from '@/utils/tx'
import { MaxUint256 } from "@ethersproject/constants";
import { BigNumber } from 'bignumber.js'


export default {
  name: 'vault_manager',
  components: {
    TagList,
    AccessControl
  },
  data () {
    return {
      newStrategyAddr: '',
      modalShow: false,
      modalTitle: '',
      vaultList: [],
      ruleValidate: {
        name: [
          {
            required: true,
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        strategy: [
          {
            required: true,
            message: 'The strategy cannot be empty',
            trigger: 'blur'
          }
        ],
      },
      selectLoading: false,
      select: null,
      selectList: [],
      selectPlaceholder: '',
      modalType: '',
      modalForm: {},
      modalLoading: true,
      custodyIndex: null,
      spinShow: false,
      isOwner: window.isOwner,
      myAddr: window.currAddress,
      tokenList: [],
      haveRole: isOwner
    }
  },
  async mounted () {
    await this.onClickRefresh()
    this.custodyIndex = contract.getCustodyIndex()
  },

  methods: {
    divDecimals: tools.divDecimals,
    mulDecimals: tools.mulDecimals,
    doCopy (txt) {
      // if(txt)
      this.$copyText(txt).then((e) => {
        this.$Message.success('已复制到粘贴板')
      }, function (e) {
        this.$Message.error('复制失败')
      })
    },
    onClickEditStrategy (item) {
      this.modalTitle = `设置【${item.name}】的策略`
      this.selectPlaceholder = '请选择'
      this.modalType = 'strategy'
      this.selectList = contract.loadStrategiesFromCache()
      this.modalForm = {}
      this.modalForm.strategy = item.strategyAddr
      this.modalForm.vaultAddr = item.address
      this.modalShow = true

      contract.loadStrategies()
    },
    onClickEditName (item) {
      this.modalTitle = `设置【${item.name}】的名称`
      this.modalType = 'vaultName'
      this.modalForm = {}
      this.modalForm.name = item.name
      this.modalForm.vaultAddr = item.address
      this.modalShow = true

    },
    onClickAdd () {
      this.modalTitle = `创建金库`
      this.selectPlaceholder = '请选择'
      this.modalForm = {}
      this.modalType = 'create'
      this.selectList = contract.loadStrategiesFromCache()
      this.modalShow = true

      contract.loadStrategies()
    },
    onClickEditOwner (item) {
      this.modalTitle = `移交【${item.name}】的 Owner`
      this.modalType = 'owner'
      this.modalForm = {}
      this.modalForm.owner = item.owner
      this.modalForm.vaultAddr = item.address
      this.modalShow = true
    },
    onClickApprove (item, tokenIndex) {
      if (!item.address) return
      if (tokenIndex < 0) return
      let erc20
      if (tokenIndex < 10) {
        erc20 = contract.getERC20(item.investTokens[tokenIndex])
      } else if (tokenIndex < 20) {
        erc20 = contract.getERC20(item.supportedTokens[tokenIndex-10])
      }
      erc20.methods
        .approve(item.address, MaxUint256)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
          })
        })
    },
    onClickDepositToTargetPrj (item, tokenIndex) {
      if (!item.address) return
      if (tokenIndex < 0) return
      let vault = contract.getStrategy(item.address)
      let tokenAddress = item.investTokens[tokenIndex]
      let tokenAmount = item.depositInvestValue0
      if (!tokenAmount) return
      let value = this.mulDecimals(tokenAmount, item.investTokenInfos[tokenIndex].decimals)
      if (value == 0) return
      if (tokenAddress == 0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE) {
        vault.methods
            .depositToTargetPrj(tokenAddress, value.toString())
            .send({ from: window.currAddress, value: value.toString() }, (error, transactionHash) => {
              waitForTx(this, error, transactionHash, (receipt) => {
                if (!error) this.loadVaultSt()
              })
            })
      } else {
          vault.methods
            .depositToTargetPrj(tokenAddress, value.toString())
            .send({ from: window.currAddress }, (error, transactionHash) => {
              waitForTx(this, error, transactionHash, (receipt) => {
                if (!error) this.loadVaultSt()
              })
            })
        }
    },
    onClickDeposit (item, tokenIndex) {
      if (!item.address) return
      if (tokenIndex < 0) return
      let vault = contract.getStrategy(item.address)
      let tokenAddress = item.supportedTokens[tokenIndex-10]
      let tokenAmount = tokenIndex == 10 ? item.depositValue0 : (tokenIndex == 11 ? item.depositValue1 : item.depositValue2)
      if (!tokenAmount) return
      let value = this.mulDecimals(tokenAmount, item.supportedTokenInfos[tokenIndex-10].decimals)
      if (value == 0) return
      vault.methods
        .deposit(tokenAddress, value.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
          })
        })
    },
    async onClickCalcEarn (item, index) {
      item.borrowInfo = ""
      this.$set(this.vaultList, index, item)
      if (!item.address || !item.collateralToken  || !item.borrowToken || !item.borrowTokenRatio) return
      if (item.collateralToken == item.borrowToken) return
      let vault = contract.getStrategy(item.address)
      console.log([item.collateralToken.toString(), item.borrowToken.toString()], item.borrowTokenRatio.toString())
      let ret = await vault.methods.calcEarn([item.collateralToken.toString(), item.borrowToken.toString()], item.borrowTokenRatio.toString()).call({ from: window.currAddress })
      let toLoanAmount = ret["0"]
      let toDepositAmount = ret["1"]
      let toBorrowAmount = ret["2"]
      let exchangeMinAmountOut = ret["3"]
      item.earnAmounts = [toLoanAmount, toDepositAmount, toBorrowAmount, exchangeMinAmountOut]
      // for testing
      // item.earnAmounts = [toLoanAmount, toDepositAmount, toBorrowAmount, toLoanAmount+1]

      item.collateralTokenInfo = await contract.getERC20Info(item.collateralToken.toString())
      item.borrowTokenInfo = await contract.getERC20Info(item.borrowToken.toString())

      item.toLoanAmount = this.divDecimals(toLoanAmount, item.collateralTokenInfo.decimals).toString()
      item.toDepositAmount = this.divDecimals(toDepositAmount, item.collateralTokenInfo.decimals).toString()
      item.toBorrowAmount = this.divDecimals(toBorrowAmount, item.borrowTokenInfo.decimals).toString()
      item.exchangeMinAmountOut = this.divDecimals(exchangeMinAmountOut, item.collateralTokenInfo.decimals).toString()
      console.log("  闪电贷数量： " + item.toLoanAmount + " "+ item.collateralTokenInfo.symbol
        + "， 抵押数量： " + item.toDepositAmount + " " + item.collateralTokenInfo.symbol
        + "， 借款数量： " + item.toBorrowAmount + " " + item.borrowTokenInfo.symbol
        + "， 兑换后数量： " + item.exchangeMinAmountOut)

      ret = await vault.methods.earn([item.collateralToken.toString(), item.borrowToken.toString()], item.earnAmounts).call({ from: window.currAddress })
      let currentUtilization = this.divDecimals(ret["0"], 6)
      let maxUtilization = this.divDecimals(ret["1"], 6)
      item.borrowInfo = "  闪电贷数量： " + item.toLoanAmount + " "+ item.collateralTokenInfo.symbol
        + "， 抵押数量： " + item.toDepositAmount + " " + item.collateralTokenInfo.symbol
        + "， 借款数量： " + item.toBorrowAmount + " " + item.borrowTokenInfo.symbol
        + "， 兑换后数量： " + item.exchangeMinAmountOut + " " + item.collateralTokenInfo.symbol
        + ",  滑点：0.5%"
        + ", 当前利用率：" + currentUtilization + ", 最大利用率：" + maxUtilization

      this.$set(this.vaultList, index, item)
    },
    onClickEarn (item) {
      if (!item.address || !item.collateralToken  || !item.borrowToken || !item.toLoanAmount) return
      let vault = contract.getStrategy(item.address)

      vault.methods
        .earn([item.collateralToken.toString(), item.borrowToken.toString()], item.earnAmounts)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
          })
        })
    },
    onClickClaim (item) {
      let vault = contract.getStrategy(item.address)
      vault.methods
        .claim()
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
          })
        })
    },
    onClickExit (item) {
      if (!item.address) return
      let vault = contract.getStrategy(item.address)
      vault.methods
        .exit()
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
          })
        })
    },
    onClickRedeem (item) {
      let vault = contract.getStrategy(item.address)
      vault.methods
        .redeemInvest()
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
          })
        })
    },
    onClickWithdraw (item, index) {
      if (!item.address || !item.withdrawValue) return
      let vault = contract.getVault(item.address)
      let value = this.mulDecimals(item.withdrawValue, item.withdrawTokenInfo.decimals)
      vault.methods
        .withdraw(item.withdrawToken, value.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) {
              this.loadVaultSt()
              this.onSelectWithdrawToken(item, index)
            }
          })
        })
    },
    onClickWithdrawETH (item, index) {
      if (!item.address) return
      let vault = contract.getVault(item.address)
      vault.methods
        .withdraw("0x0000000000000000000000000000000000000000", "0")
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) {
              this.loadVaultSt()
            }
          })
        })
    },
    onClickMaxDeposit (item, index, idx) {
      if (idx == 0) {
        item.depositInvestValue0 = this.divDecimals(item.availableInvestTokenBalances[0], item.investTokenInfos[0].decimals).toString()
      } else if (idx == 10) {
        item.depositValue0 = this.divDecimals(item.availableSupportedTokenBalances[0], item.supportedTokenInfos[0].decimals).toString()
      } else if (idx == 11) {
        item.depositValue1 = this.divDecimals(item.availableSupportedTokenBalances[1], item.supportedTokenInfos[1].decimals).toString()
      } else if (idx == 12) {
        item.depositValue1 = this.divDecimals(item.availableSupportedTokenBalances[2], item.supportedTokenInfos[2].decimals).toString()
      }
      this.$set(this.vaultList, index, item)
    },
    onClickMaxWithdraw (item, index) {
      item.withdrawValue = this.divDecimals(item.withdrawTokenBalance, item.withdrawTokenInfo.decimals).plus(1).toString()
      this.$set(this.vaultList, index, item)
    },
    async onSelectWithdrawToken (item, index) {
      let token = await contract.getERC20Info(item.withdrawToken)
      let tokenBalance = await contract.getERC20BalanceOf(item.withdrawToken, item.address)
      item.withdrawTokenInfo = token
      item.withdrawTokenBalance = tokenBalance
      this.$set(this.vaultList, index, item)
    },
    modalDone () {
      this.$refs['modalForm'].validate((valid) => {
        if (valid) {
          if (this.modalType === 'create') {
            this.createVault(this.modalForm.strategy, this.modalForm.name)
          } else if (this.modalType === 'strategy') {
            this.editStrategy(this.modalForm.strategy, this.modalForm.vaultAddr)
          } else if (this.modalType === 'vaultName') {
            this.editVaultName(this.modalForm.name, this.modalForm.vaultAddr)
          } else if (this.modalType === 'owner') {
            this.modalForm.owner = tools.checkNoticeAddressValid(this, this.modalForm.owner)
            if (!this.modalForm.owner) {
              this.modalLoading = false
              return
            }
            this.editVaultOwner(this.modalForm.owner, this.modalForm.vaultAddr)
          }
        } else {
          this.modalLoading = false
        }
      })
    },
    async onClickRefresh () {
      this.spinShow = true
      await contract.loadStrategies()
      this.vaultList = await contract.loadVaults()
      this.loadVaultSt()
      this.loadTokenList()
      this.spinShow = false
    },
    loadVaultSt () {
      this.vaultList.forEach(async (item, index) => {
        let vault = new web3.eth.Contract(Vault, item.address)
        item.owner = await vault.methods.owner().call()

        item.isOwner = item.owner === window.currAddress
        item.pendingOwner = await vault.methods.pendingOwner().call()
        this.$set(this.vaultList, index, item)

        item.isOperator = await vault.methods.isOperator(window.currAddress).call() || item.isOwner
        item.isHarvestor = await vault.methods.isHarvestor(window.currAddress).call() || item.isOperator
        this.$set(this.vaultList, index, item)

        item.isRelated = item.pendingOwner === window.currAddress || item.isHarvestor
        if (!item.isRelated && !this.isOwner) return
        this.haveRole = true

        this.$set(this.vaultList, index, item)

        item.strategyAddr = await vault.methods.strategy().call()

        let strategy = new web3.eth.Contract(Strategy, item.address)
        item.strategyName = await strategy.methods.strategyName().call({ from: window.currAddress })
        item.investTokens = await strategy.methods.investTokens().call({ from: window.currAddress })
        item.borrowTokens = await strategy.methods.borrowTokens().call({ from: window.currAddress })
        item.rewardTokens = await strategy.methods.rewardTokens().call({ from: window.currAddress })
        item.supportedTokens = await strategy.methods.supportedTokens().call({ from: window.currAddress })

        let investTokenInfos = [], investTokenBalances = [], availableInvestTokenBalances = [], isInvestTokenApproveds = []
        let borrowTokenInfos = [], borrowTokenBalances = [], availableBorrowTokenBalances = [], isBorrowTokenApproveds = []
        let rewardTokenInfos = [], rewardTokenBalances = []
        let supportedTokenInfos = [], supportedTokenBalances = [], availableSupportedTokenBalances = [], isSupportedTokenApproveds = []

        for (let investToken of item.investTokens) {
            // 添加
            if(investToken == 0x0000000000000000000000000000000000000000) continue
            if(investToken == 0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE) {
                investTokenInfos.push({
                    name: "ETH",
                    symbol: "ETH",
                    decimals: 18,
                  })
                investTokenBalances.push(await contract.getEthBalanceOf(item.address))
                let availableInvestTokenBalance = await contract.getEthBalanceOf(window.currAddress)
                availableInvestTokenBalances.push(availableInvestTokenBalance)
                isInvestTokenApproveds.push(true)
            } else {
                investTokenInfos.push(await contract.getERC20Info(investToken))
                investTokenBalances.push(await contract.getERC20BalanceOf(investToken, item.address))
                let availableInvestTokenBalance = await contract.getERC20BalanceOf(investToken, window.currAddress)
                availableInvestTokenBalances.push(availableInvestTokenBalance)
                let allowance = await contract.getERC20Allowance(investToken, window.currAddress, item.address)
                isInvestTokenApproveds.push((new BigNumber(allowance)).isGreaterThan (new BigNumber(availableInvestTokenBalance)))
            }
        }
        item.investTokenInfos = investTokenInfos
        item.investTokenBalances = investTokenBalances
        item.availableInvestTokenBalances = availableInvestTokenBalances
        item.isInvestTokenApproveds = isInvestTokenApproveds

        for (let borrowToken of item.borrowTokens) {
            // 添加
            if(borrowToken == 0x0000000000000000000000000000000000000000) continue
            borrowTokenInfos.push(await contract.getERC20Info(borrowToken))
            borrowTokenBalances.push(await contract.getERC20BalanceOf(borrowToken, item.address))
            let availableBorrowTokenBalance = await contract.getERC20BalanceOf(borrowToken, window.currAddress)
            availableBorrowTokenBalances.push(availableBorrowTokenBalance)
            let allowance = await contract.getERC20Allowance(borrowToken, window.currAddress, item.address)
            isBorrowTokenApproveds.push((new BigNumber(allowance)).isGreaterThan (new BigNumber(availableBorrowTokenBalance)))
        }
        item.borrowTokenInfos = borrowTokenInfos
        item.borrowTokenBalances = borrowTokenBalances
        item.availableBorrowTokenBalances = availableBorrowTokenBalances
        item.isBorrowTokenApproveds = isBorrowTokenApproveds

        for (let rewardToken of item.rewardTokens) {
            rewardTokenInfos.push(await contract.getERC20Info(rewardToken))
            rewardTokenBalances.push(await contract.getERC20BalanceOf(rewardToken, item.address))
        }

        item.rewardTokenInfos = rewardTokenInfos
        item.rewardTokenBalances = rewardTokenBalances
        this.$set(this.vaultList, index, item)

        item.claimable = await strategy.methods.claim().call({ from: window.currAddress })

        for (let token of item.supportedTokens) {
            // 添加
            if(token == 0x0000000000000000000000000000000000000000) continue
            this.onCreateToken(token)
            supportedTokenInfos.push(await contract.getERC20Info(token))
            supportedTokenBalances.push(await contract.getERC20BalanceOf(token, item.address))
            let availableSupportedTokenBalance = await contract.getERC20BalanceOf(token, window.currAddress)
            availableSupportedTokenBalances.push(availableSupportedTokenBalance)
            let allowance = await contract.getERC20Allowance(token, window.currAddress, item.address)
            isSupportedTokenApproveds.push((new BigNumber(allowance)).isGreaterThan (new BigNumber(availableSupportedTokenBalance)))
        }
        item.supportedTokenInfos = supportedTokenInfos
        item.supportedTokenBalances = supportedTokenBalances
        item.availableSupportedTokenBalances = availableSupportedTokenBalances
        item.isSupportedTokenApproveds = isSupportedTokenApproveds

        item.investedBalances = await strategy.methods.investedBalances().call({ from: window.currAddress })
        item.borrowedBalances = await strategy.methods.borrowedBalances().call({ from: window.currAddress })
        let riskIndex = await strategy.methods.riskIndex().call({ from: window.currAddress })
        item.riskIndex = riskIndex["0"]

        item.borrowInfo = ""
        item.utilizationInfo = ""
        item.toLoanAmount = null
        item.repayAmount = null
        item.ethBalance = await contract.getEthBalanceOf(item.address)
        this.$set(this.vaultList, index, item)
        console.log(item)
      })
    },
    loadTokenList () {
      let tokenListMap = Store.get('tokenList') || {}
      let tokenList = tokenListMap[window.net] || []
        this.tokenList = tokenList
    },
    async onCreateToken (val) {
      val = tools.checkNoticeAddressValid(this, val)
      if (!val) {
        return
      }

      let tokenListMap = Store.get('tokenList') || {}
      let tokenList = tokenListMap[window.net] || []
      for (let token of tokenList) {
        if (token.address === val) {
          // item.withdrawToken = val
          return
        }
      }
      let ercInfo = await contract.getERC20Info(val)
      ercInfo.address = val
      tokenList.push(ercInfo)
      tokenListMap[window.net] = tokenList
      Store.set('tokenList', tokenListMap)
      this.loadTokenList()
    },

    createVault (strategyAddr, vaultName) {
      this.custodyIndex.methods
        .createVault(strategyAddr, vaultName)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.onClickRefresh()
            if (!error) {
              this.modalShow = false
            }
          })
        })
    },
    editStrategy (strategyAddr, vaultAddr) {
      let vault = contract.getVault(vaultAddr)
      vault.methods
        .setStrategy(strategyAddr)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
            if (!error) {
              this.modalShow = false
            }
          })
        })
    },
    editVaultName (vaultName, vaultAddr) {
      this.custodyIndex.methods
        .renameVault(vaultAddr, vaultName)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.onClickRefresh()
            if (!error) {
              this.modalShow = false
            }
          })
        })
    },
    editVaultOwner (ownerAddr, vaultAddr) {
      let vault = contract.getVault(vaultAddr)
      vault.methods
        .proposeOwnership(ownerAddr)
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
            if (!error) {
              this.modalShow = false
            }
          })
        })
    },
    onClickAcceptOwner (vaultAddr) {
      let vault = contract.getVault(vaultAddr)
      vault.methods
        .acceptOwnership()
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) this.loadVaultSt()
          })
        })
    },

    async getTokenInfo (address, method) {
      return await contract.getERC20Info(address, method)
    },
    getStrategyName (stAddr,) {

    }
  }
}
</script>

<style scoped>

    .opRow {
        margin-top: 10px;
    }
</style>
